import { createI18n } from 'vue-i18n';
import { generateRule } from '@utils/judgeDomain';
import { isApp } from '@utils/is';
import { deepEscapeVueI18nAtInMessages } from '@utils/escapeVueI18nAt';
import mc from '../utils/mc';
import { i18nMessages } from './message';

// 协议类页面目前只有英文
const lang = 'en';
const tag = ['h5/privacy', 'h5/common'];
const options = {
  legacy: false,
  locale: lang,
  fallbackLocale: 'en',
  fallbackWarn: false,
  messages: deepEscapeVueI18nAtInMessages(i18nMessages),
};
const i18n = createI18n(options);
mc.getLanguage({ tag, lang, replaceRules: generateRule() }).then((res: any) => {
  const localeKey = lang as keyof typeof i18nMessages;
  const mergeMsg = deepEscapeVueI18nAtInMessages({
    ...(i18nMessages[localeKey] || {}),
    ...res.allTag,
  });
  i18n.global.setLocaleMessage(lang, mergeMsg);
  if (!isApp()) {
    document.title = i18n.global.t('ctg_privacy_title');
  }
});
window.document.documentElement.lang = lang;
window.document.documentElement.dir = /^ar/.test(lang) ? 'rtl' : 'ltr';
export default i18n;
